import React, { Component } from "react";
import "../App.css";
import mindtree from "../images/mindtree.png";
import escape from "../images/escape.png";
import environment from "../images/environment.png";
import vitality from "../images/vitality.png";
import bg_wisps from "../images/bg_wisps.png";
import { Link } from "react-router-dom";

class Categories extends Component {
  render() {
    return (
      <>
        <div className="categories-wrapper category-child-styles">
          <img src={bg_wisps} className="categories_background" />
          <img src={mindtree} className="mindfullness-image category-image" />
          <div className="mindfullness-text">
            <h1>Achieve Mindfulness</h1>
            <p>
              Mindfulness is a type of meditation in which you focus on being
              intensely aware of what you're sensing and feeling in the moment,
              without interpretation or judgment.
            </p>
            <p>
              Practicing mindfulness involves breathing methods, guided imagery,
              and other practices to relax the body and mind and help reduce
              stress.
              <Link className="catLinks" to="/mindfulness">
                <p>Take a breath</p>
              </Link>
            </p>
          </div>
          <img src={escape} className="escape-image category-image" />
          <div className="escape-text">
            <h1>Escape Reality</h1>
            <p>
              By engaging in some healthy escapism, you can leave any pressing
              concerns or worries behind. In a lot of cases, emotions are
              fleeting, and we simply need to ride them out.
            </p>
            <p>
              With distractions to remove you from the toxic headspace, this can
              happen without dragging you along for the process.
              <Link className="catLinks">
                <p>Choose your Escape</p>
              </Link>
            </p>
          </div>
          <img src={environment} className="environment-image category-image" />
          <div className="environment-text">
            <h1>Create A New Environment</h1>
            <p>
              Everything from the house, city, and the state you live in to the
              weather in your area, the social climate, and your work
              environment can affect your mental health.
            </p>
            <p>
              These places you spend a lot of time in can have a significant
              impact on your well-being—both physically and mentally.
              <Link className="catLinks">
                <p>Start Building</p>
              </Link>
            </p>
          </div>
          <img src={vitality} className="vitality-image category-image" />
          <div className="vitality-text">
            <h1>Increase Vitality</h1>
            <p>
              Living a healthy lifestyle can help prevent chronic diseases and
              long-term illnesses. Feeling good about yourself and taking care
              of your health are important for your self-esteem and self-image.
            </p>
            <p>
              Maintain a healthy lifestyle by doing what is right for your body.
              <Link className="catLinks">
                <p>Boost Health</p>
              </Link>
            </p>
          </div>
        </div>
      </>
    );
  }
}

export default Categories;
